import { HttpClient, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { ClienteUsuarioInterface } from "../../_interfaces/cliente.interface";

@Injectable({
  providedIn: 'root'
})

export class AutenticacaoService {
  private _url: string;

  constructor(private http: HttpClient) {
    this._url = `${environment.apiUrl}`;
  }

  public efetuarLogin(pObj: ClienteUsuarioInterface) {
    return this.http.post(`${this._url}/Autenticacao/Login`, pObj).toPromise();
  }

  public selecionarRolesUsuario(pIdClienteUsuario: number) {
    return this.http.get(`${this._url}/Autenticacao/SelecionarRolesUsuario/${pIdClienteUsuario}`).toPromise();
  }
}
